import React, { useEffect, useState, useRef } from "react";
import axios from 'axios';
import Header from "./Header";

const BannerSection = () => {
    const [bannerSections, setBannerSections] = useState([]);
    const [subcategory, setsubcategory] = useState([]);
    const [subId, setSubId] = useState("");
    const [loading, setLoading] = useState(true);
    const [adding, setAdding] = useState(false);
    const [deletingId, setDeletingId] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [error, setError] = useState(null);
    const fileInputRef = useRef(null);
    const [tag, setTag] = useState("");
const [label, setLabel] = useState("");
const [price, setPrice] = useState("");
const [badge, setBadge] = useState("");


    const fetchSubCategories = async () => {
        try {
            const response = await axios.get('https://projects.sninfoserv.com/welb-api/admin/categories/subcategories/');
            // console.log(response.data);
            if (response.data.status === "success") {
                setsubcategory(response?.data.data);
            } else {
                console.error(response.data.error?.message);
            }
        } catch (err) {
            setError(err.message);

        }
    };

    const fetchBannerSections = async () => {
        try {
            const res = await fetch('https://projects.sninfoserv.com/welb-api/home/combo/');
            const data = await res.json();
            // console.log(data.data);
            if (data.status === "success") setBannerSections(data.data);
            else throw new Error("Failed to fetch Budget sections");
        } catch (err) {
            setError(err.message);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            await fetchSubCategories();
            await fetchBannerSections();
            setLoading(false);
        };
        fetchData();
    }, []);

   

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessMessage("");

           if (bannerSections.length >= 6) {
            setError("Maximum 6 Items products only allowed.");
            return;
        }

        if (!subId) { setError("Please select a subcategory"); return; }
       if (!tag.trim()) { setError("Tag is required"); return; }
if (!label.trim()) { setError("Label is required"); return; }
if (!price.trim()) { setError("Price is required"); return; }

        setAdding(true);
        try {
            const formData = new FormData();
            formData.append("sub_id", subId);
            formData.append("tag", tag);
            formData.append("label", label);
            formData.append("price", price);
            formData.append("badge", badge);


            const response = await fetch('https://projects.sninfoserv.com/welb-api/home/addcombo/', {
                method: "POST",
                body: formData,
            });

            const data = await response.json();
            if (data.status === "success") {
                setSuccessMessage("Budget section added successfully!");
                await fetchBannerSections();
                setSubId("");
                setTag("");
                setLabel("");
                setPrice("");
                setBadge("");
                if (fileInputRef.current) fileInputRef.current.value = "";
            } else {
                throw new Error(data.message || "Failed to add Budget section");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setAdding(false);
        }
    };

    const handleDelete = async (id) => {
        setDeletingId(id);
        setError(null);
        setSuccessMessage("");
        try {
            const response = await fetch('https://projects.sninfoserv.com/welb-api/home/delete-combo/', {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id }),
            });
            const data = await response.json();
            // console.log(data);
            if (data.status === "success") {
                setSuccessMessage("Budget section removed successfully!");
                setBannerSections((prev) => prev.filter((b) => b.id !== id));
            } else {
                throw new Error(data.message || "Failed to delete Budget section");
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setDeletingId(null);
        }
    };

    return (
        <>
            <Header />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body">
                                {successMessage && (
                                    <div className="alert alert-success alert-dismissible fade show" role="alert">
                                        {successMessage}
                                        <button type="button" className="btn-close" onClick={() => setSuccessMessage("")}></button>
                                    </div>
                                )}
                                {error && (
                                    <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                        {error}
                                        <button type="button" className="btn-close" onClick={() => setError(null)}></button>
                                    </div>
                                )}

                                <div className="mb-3">
                                    <h5
                                        className="mb-0 fw-bold d-inline-block px-3 py-2 rounded"
                                        style={{
                                            fontSize: '30px',
                                            background: "linear-gradient(135deg, #0d6efd15, #0d6efd08)",
                                            borderLeft: "5px solid #0d6efd",
                                            color: "#0d6efd",
                                            letterSpacing: "0.3px"
                                        }}
                                    >
                                        Add Budget Return gift 
                                    </h5>
                                </div>

                                <form onSubmit={handleSubmit}>
                                    <div className="form-body">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="mb-3">
                                                    <label>Sub Category</label>
                                                    <select
                                                        className="form-control"
                                                        name="sub_category"
                                                        value={subId}
                                                        onChange={(e) => setSubId(e.target.value)}
                                                    >
                                                        <option value="">-- Select Sub Category --</option>

                                                        {subcategory.map((sub) => (
                                                            <option key={sub.sub_id} value={sub.sub_id}>
                                                                {sub.sub_cate}
                                                            </option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
<div className="col-md-3">
  <div className="mb-3">
    <label>Tag</label>
    <input
      type="text"
      className="form-control"
      placeholder="Enter tag"
      value={tag}
      onChange={(e) => setTag(e.target.value)}
    />
  </div>
</div>

<div className="col-md-3">
  <div className="mb-3">
    <label>Label</label>
    <select value={label} onChange={(e) => setLabel(e.target.value)} className="form-control">
  <option value="">Select Label</option>
  <option value="Under">Under</option>
  <option value="Above">Above</option>
</select>
  </div>
</div>

<div className="col-md-3">
  <div className="mb-3">
    <label>Price</label>
    <input
      type="text"
      className="form-control"
      placeholder="Enter price range"
      value={price}
      onChange={(e) => setPrice(e.target.value)}
    />
  </div>
</div>

<div className="col-md-3">
  <div className="mb-3">
    <label>Badge</label>
<select value={badge} onChange={(e) => setBadge(e.target.value)} className="form-control">
  <option value="">Select Badge</option>
  <option value="Hot Deal">Hot Deal</option>
  <option value="Trending">Trending</option>
  <option value="Premium">Premium</option>
</select>
  </div>
</div>

                                        </div>


                                        <div className="row">
                                            <div className="col-md-2">
                                                <div className="form-actions">
                                                    <button
                                                        type="submit"
                                                        className="btn btn-light-primary text-primary font-medium mb-3"
                                                        disabled={adding}
                                                    >
                                                        {adding ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                                Adding…
                                                            </>
                                                        ) : (
                                                            <>
                                                                <i className="ti ti-plus me-1"></i> Add
                                                            </>
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </form>

                                <hr />

                                <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
                                    <h5 className="mb-0">Budget Sections List</h5>
                                    <span className="badge bg-dark fs-6">
                                        {bannerSections.length} {bannerSections.length === 1 ? "Section" : "Sections"}
                                    </span>
                                </div>

                                <div className="table-responsive" style={{ overflowX: "auto" }}>
                                    <table className="table border table-striped table-bordered align-middle">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Sub Category</th>
                                                <th>tag</th>
                                                <th>label</th>
                                                 <th>price</th>             
                                                  <th>badge</th>
                                                <th className="text-center">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center py-4">
                                                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                        Loading Budget sections…
                                                    </td>
                                                </tr>
                                            ) : bannerSections.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center fw-bold">
                                                        No Budget sections added yet.
                                                    </td>
                                                </tr>
                                            ) : (
                                                bannerSections.map((section, index) => (
                                                    <tr key={section.id}>
                                                        <td>{index + 1}</td>
                                                       
                                                        <td>
                                                            <span className="badge bg-light-primary text-primary">
                                                                {
                                                                    subcategory.find(sub => sub.sub_id === section.sub_id)?.sub_cate || "N/A"
                                                                }
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <h6 className="mb-0">{section.tag}</h6>
                                                        </td>
                                                        <td>
                                                            <h6 className="mb-0">{section.label}</h6>
                                                        </td>
                                                        <td>
                                                            <h6 className="mb-0">{section.price}</h6>
                                                        </td>
                                                         <td>
                                                            <h6 className="mb-0">{section.badge}</h6>
                                                        </td>
                                                        <td className="text-center">
                                                            <div className="btn-group">
                                                                <button
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => handleDelete(section.id)}
                                                                    disabled={deletingId === section.id}
                                                                >
                                                                    {deletingId === section.id ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-1" role="status"></span>
                                                                            Removing…
                                                                        </>
                                                                    ) : (
                                                                        <i className="ti ti-trash"></i>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default BannerSection;